var hornstrup = hornstrup || {};

hornstrup.countTo = hornstrup.countTo || function () {
    var self = this;
    var defaultOptions = {
        from: 0,  // the number the element should start at
        to: 100,  // the number the element should end at
        speed: 1000,  // how long it should take to count between the target numbers
        refreshInterval: 100,  // how often the element should be updated
        decimals: 0,  // the number of decimal places to show
        onUpdate: null,  // callback method for every time the element is updated,
        onComplete: null  // callback method for when the element finishes updating
    }
    this.init = function (callback) {
        $('#payoff .payoff__item .payoff__number').each(function(){
            $(this).attr({'data-maxNumber':  $(this).text()*1}).text('0');
        });
    }
    this.checkIfCounterShouldRun = function (callback) {
        if(! $('#payoff.has-counted').length){
            if(isScrolledIntoView($('#payoff'))){self.start();}
        }
    }
    this.start = function (callback) {
        $('#payoff .payoff__item .payoff__number').each(function(){
            var numberMax=$(this).attr('data-maxNumber')*1;
            self.countTo({
                from: 0,
                to:  numberMax,
                speed:1000,
                refreshInterval: 50,
                onComplete: function(value) {
                    //console.debug(this);
                }
            },$(this));
        });
        $('#payoff').addClass('has-counted');
    }
    this.countTo = function (options, element) {
         options = $.extend({},defaultOptions, options || {});

        // how many times to update the value, and how much to increment the value on each update
        var loops = Math.ceil(options.speed / options.refreshInterval),
            increment = (options.to - options.from) / loops;

        return $(element).each(function() {
            var _this = element,
                loopCount = 0,
                value = options.from,
                interval = setInterval(updateTimer, options.refreshInterval);

            function updateTimer() {
                value += increment;
                loopCount++;
                $(_this).html(value.toFixed(options.decimals));

                if (typeof(options.onUpdate) == 'function') {
                    options.onUpdate.call(_this, value);
                }

                if (loopCount >= loops) {
                    clearInterval(interval);
                    value = options.to;

                    if (typeof(options.onComplete) == 'function') {
                        options.onComplete.call(_this, value);
                    }
                }
            }
        });
    }

    // public functions:
    return {
        checkIfCounterShouldRun: checkIfCounterShouldRun,
        init: init
    };
}();



function isScrolledIntoView(elem)
{
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}